import moment from 'moment';
import './CampusBox.scss';
import temp_course_photo from './../../../../assets/images/temp-course-photo.jpeg';
import { ReactComponent as ClassIcon } from './../../../../assets/images/class-icon.svg';
import { ReactComponent as ContentIcon } from './../../../../assets/images/contenItemIcon.svg';
import CampusBoxProps from './CampusBoxProps';
import { useNavigate } from 'react-router-dom';

const CampusBox = (props: CampusBoxProps) => {
    const navigate = useNavigate();
    const { item, type, isPastHebrew } = props;

    const goToCourse = () => {
        navigate('/my-campus/course/timeline/' + item.bbCourseId)
    }

    const goToEvent = () => {
        navigate('/my-campus/event/timeline/' + item._id, { state: { fromMyCampus: true } })
    }

    const goToEventTasks = () => {
        navigate('/my-campus/event/tasks/' + item._id, { state: { fromMyCampus: true } })
    }

    return (
        item.eventTypeId === "Course" ? (
            <div className="course-box pointer" onClick={goToCourse}>
                <div className="bb-icon">BB</div>
                <img className="course-photo" src={item.photo ? item.photo : temp_course_photo} alt="course"/>
                <div className="title d-flex align-items-start">{item.eventName}</div>
                {item.nextLesson ?
                    <div className="note">{`Next Lesson: ${moment(item.nextLesson).format('ll').toUpperCase()}`}</div>
                    :
                    <div className="note">{'Enter'}</div>
                }
            </div>
        ) : (
            <div className={`course-box ${type === "past" ? 'campusBoxPast' : ""} ${isPastHebrew ? 'pastHebrew' : ""} ${item.language === "English" ? null : 'campusBoxPastRTL'}`} dir={`${item.language === "English" ? 'ltr' : 'rtl'}`} >
                {type !== "past" ? <img className="course-photo" src={item.thumbnail ? item.thumbnail : temp_course_photo} alt="course" /> : null}
                <div className={`title d-flex flex-column align-items-start ${type === "past" ? 'campusBoxPastTitle' :null} ${item.language === "English" ? null : 'campusBoxPastTitleRTL'}`}>
                    {type !== "past" && item.seminarTasks && item.seminarTasks.length > 0 &&
                        <div className={`seminarOpenTasks pointer`} onClick={goToEventTasks}>
                            <span>Tasks </span>
                            <span>{item.seminarTasks && item.seminarTasks.length > 0 && item.seminarTasks.length}</span>
                        </div>
                    }

                    <div className={`pointer`} onClick={goToEvent}>{item.eventTitle}</div>
                </div>
                {type === "past" ?
                    <div className={`pastMetaDataContainer`}>
                    {type === "past" ? <div className={`pastSeminarMetaData ${item.language === "English" ? null : 'pastSeminarMetaDataRTL'}`}> {moment(item.dtStartDate).format('MM/DD/YYYY')} - {moment(item.dtEndDate).format('MM/DD/YYYY')}</div> :null}
                        {item.sessions && item.sessions.length > 0 && type === "past" ? <div className={`pastSeminarMetaData ${item.language === "English" ? 'ml-2' : 'pastSeminarMetaDataRTL'}`}><ClassIcon className={`ClassIconIcon`} /> {item.sessions.length} <div className={`SessionsTerm`}> {item.language === "English" ? "Sessions" : 'שיעורים'}</div></div> : null}
                        {item.related && item.related.length > 0 && type === "past" ? <div className={`pastSeminarMetaData ${item.language === "English" ? 'ml-2' : 'pastSeminarMetaDataRTL'}`}><ContentIcon className={`pastContentIcon`} /> {item.related.length} <div className={`SessionsTerm`}> {item.language === "English" ? "Content Items" : 'מסמכים'}</div> </div> : null}
                    </div>
                : null}

                {/*{type === "past" ?*/}
                {/*    <div className={`campusBoxCTA ${type === "past" ? 'campusBoxPastCTA' :null} ${item.language === "English" ? null : 'campusBoxPastCTARTL'}`}>{*/}
                {/*        item.language === "English" ? "Enter" : item.language === "Arabic" ? "مدخل" : 'כניסה'*/}
                {/*    }</div>*/}
                {/*: null}*/}

                {item.nextLesson ?
                    <div className="note">{`Next Lesson: ${moment(item.nextLesson).format('ll').toUpperCase()}`}</div>
                    :
                    <div onClick={goToEvent} className={`pointer note campusBoxCTA ${type !== "past" ? 'campusBoxPastCTA' :null} ${item.language === "English" ? null : 'campusBoxPastCTARTL'}`}>{
                        item.language === "English" ? "Enter" : item.language === "Arabic" ? "مدخل" : 'כניסה'
                    }</div>
                }
            </div>
        )

    )
}

export default CampusBox;